import { Component, OnInit } from '@angular/core';
import { IReportEmbedConfiguration, models } from "powerbi-client";

import { PowerBiService } from '../../../../services/powerbi.service';
import { map } from 'rxjs';


type PowerBiCred =  IReportEmbedConfiguration | null;
type Handlers = Map<string, (event: any) => void>

@Component({
  selector: 'app-claim-insights-report',
  templateUrl: './claim-insights-report.component.html',
  styleUrls: ['./claim-insights-report.component.scss']
})
export class ClaimInsightsReportComponent implements OnInit {

  powerBiCred:PowerBiCred = null;
  handlers:Handlers =  new Map([
    ['loaded', () =>{}],
    ['rendered', () =>{}],
    ['error', (event:any) => console.error(event.detail)]
  ]); 

  constructor(
  private  powerBiService: PowerBiService
  ) { }

  ngOnInit(): void {
    this.powerBiService.getAccessToken({ type:"kyo"})
    .pipe(map(res => res.data) )
    .subscribe((data) => {
       let cred:IReportEmbedConfiguration = {
          accessToken: data.embedToken.token,
          embedUrl: data.reportsDetail[0].embedUrl,
          type: 'report',
          id: data.reportsDetail[0].reportId,
          tokenType: models.TokenType.Embed,
       };
      this.powerBiCred = cred;
    })
  }

}
